module.exports = __webpack_public_path__ + "static/media/saveProperty.71989ed4.png";